import React, { createContext, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from '../../../modules/store';
import LoadingSpinner from '../LoadingSpinner';
import Card from '../Card';
import useWishList from './hooks/useWishlist';
import Intro from './elements/Intro';
import ShareWithAFriend from './elements/ShareWithAFriend';
import ShareWithUs from './elements/ShareWithUs';

export const WishlistContext = createContext(null);

const Wishlist = () => {
  const {
    waiting,
    setWaiting,
    wishlist,
    showShareWithAFriend,
    setShowShareWithAFriend,
    showShareWithUs,
    setShowShareWithUs,
    shareWithAFriendInitial,
    shareWithAFriendValidationSchema,
    shareWithUsInitial,
    shareWithUsValidationSchema,
    handleReCaptchaVerify,
    form,
    intro,
    postForm,
    disable,
  } = useWishList();

  const [hasWishlistItems, setHasWishlistItems] = useState(false);

  useEffect(() => {
    const { holidays, accommodations, activities } = wishlist || {};
    const hasItems = Boolean(
      (holidays && holidays.length > 0) ||
        (accommodations && accommodations.length > 0) ||
        (activities && activities.length > 0)
    );

    setHasWishlistItems(hasItems);
  }, [wishlist?.holidays, wishlist?.accommodations, wishlist?.activities]);

  if (waiting) {
    return <LoadingSpinner />;
  }

  if (!hasWishlistItems) {
    return (
      <WishlistContext.Provider
        value={{
          waiting,
          setWaiting,
          wishlist,
          showShareWithAFriend,
          setShowShareWithAFriend,
          showShareWithUs,
          setShowShareWithUs,
          shareWithAFriendInitial,
          shareWithAFriendValidationSchema,
          shareWithUsInitial,
          shareWithUsValidationSchema,
          handleReCaptchaVerify,
          form,
          intro,
          postForm,
          disable,
        }}
      >
        <div className="c-wishlist">
          <div className="o-wrapper o-wrapper--wide">
            <Intro showButtons={false} />
            <div class="c-wishlist__section__empty">
              You haven't added anything to your wishlist yet.
            </div>
          </div>
        </div>
      </WishlistContext.Provider>
    );
  } else {
    return (
      <WishlistContext.Provider
        value={{
          waiting,
          setWaiting,
          wishlist,
          showShareWithAFriend,
          setShowShareWithAFriend,
          showShareWithUs,
          setShowShareWithUs,
          shareWithAFriendInitial,
          shareWithAFriendValidationSchema,
          shareWithUsInitial,
          shareWithUsValidationSchema,
          handleReCaptchaVerify,
          form,
          intro,
          postForm,
          disable,
        }}
      >
        <div className="c-wishlist">
          <div className="o-wrapper o-wrapper--wide">
            <Intro showButtons={true} />
          </div>

          {wishlist.holidays.length > 0 && (
            <div className="c-cards c-cards--left">
              <div className="o-wrapper o-wrapper--wide c-cards__intro">
                <h2 className="o-after-line o-after-line--purple">Holidays</h2>
              </div>

              <div className="o-wrapper o-wrapper--wide c-cards__body">
                {wishlist.holidays.map((holiday) => (
                  <Card
                    key={`card--${holiday.id}`}
                    payload={holiday}
                    type={holiday.type}
                  />
                ))}
              </div>
            </div>
          )}

          {wishlist.accommodations.length > 0 && (
            <div className="c-cards c-cards--left">
              <div className="o-wrapper c-cards__intro">
                <h2 className="o-after-line o-after-line--purple">
                  Accommodation
                </h2>
              </div>

              <div className="o-wrapper o-wrapper--wide c-cards__body">
                {wishlist.accommodations.map((acc) => (
                  <Card key={`card--${acc.id}`} payload={acc} type={acc.type} />
                ))}
              </div>
            </div>
          )}

          {wishlist.activities.length > 0 && (
            <div className="c-cards c-cards--left">
              <div className="o-wrapper c-cards__intro">
                <h2 className="o-after-line o-after-line--purple">
                  Things To Do
                </h2>
              </div>

              <div className="o-wrapper o-wrapper--wide c-cards__body">
                {wishlist.activities.map((activity) => (
                  <Card
                    key={`card--${activity.id}`}
                    payload={activity}
                    type={activity.type}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        {showShareWithAFriend && <ShareWithAFriend />}
        {showShareWithUs && <ShareWithUs />}
      </WishlistContext.Provider>
    );
  }
};

export default Wishlist;
